import { AxiosError } from 'axios'
import { ApiErrorCode, ErrorDetail } from '@/api/apiTypes'

export function mapAxiosErrorToApiError(
  error: any,
): ErrorDetail & { code: ApiErrorCode } {
  // Check if this is an Axios response object (has data, status, headers, config)
  // This happens when an interceptor rejects with error.response instead of the full error
  if (
    error?.data &&
    error?.status &&
    error?.config &&
    typeof error.status === 'number'
  ) {
    const responseData = error.data

    return {
      message:
        responseData.message ||
        responseData.error ||
        responseData.detail?.description ||
        'Server error',
      code:
        responseData.code ||
        responseData.detail?.code ||
        mapHttpStatusToApiErrorCode(error.status),
      details: responseData,
    }
  }

  // If this is a standard AxiosError
  if (error.isAxiosError || error.response) {
    const axiosError = error as AxiosError<any>

    // If there is a response from the server
    if (axiosError.response?.data) {
      const responseData = axiosError.response.data

      return {
        message:
          responseData.message ||
          responseData.error ||
          responseData.detail?.description ||
          'Server error',
        code:
          responseData.code ||
          responseData.detail?.code ||
          mapHttpStatusToApiErrorCode(axiosError.response.status),
        details: responseData,
      }
    }

    // If there is no response (network error, timeout, etc.)
    if (axiosError.code === 'ECONNABORTED') {
      return {
        message: 'Request timeout',
        code: ApiErrorCode.TIMEOUT,
        details: error,
      }
    }

    if (!axiosError.response) {
      return {
        message: 'Network error',
        code: ApiErrorCode.NETWORK_ERROR,
        details: error,
      }
    }
  }

  // If this is not an AxiosError or response object
  console.warn('Unmapped error type:', error)
  return {
    message: error.message || 'Unknown error',
    code: ApiErrorCode.UNKNOWN,
    details: error,
  }
}

function mapHttpStatusToApiErrorCode(status: number): ApiErrorCode {
  switch (status) {
    case 400:
      return ApiErrorCode.VALIDATION_ERROR
    case 401:
      return ApiErrorCode.ACTION_IS_NOT_ALLOWED
    case 403:
      return ApiErrorCode.ACTION_IS_NOT_ALLOWED
    case 404:
      return ApiErrorCode.USER_NOT_FOUND
    case 429:
      return ApiErrorCode.TOO_MANY_ATTEMPTS
    default:
      return ApiErrorCode.UNKNOWN
  }
}
